/* DESTGLOW_SEARCH_MODAL_SAFE_V2: immediate progressive enhancement and editor lifecycle. */
(function () {
  'use strict';
  if (!window.customElements || customElements.get('search-modal')) return;
  class SearchModal extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.detailsContainer = this.querySelector('details');
      this.summaryToggle = this.querySelector('summary');
      if (!this.detailsContainer || !this.summaryToggle) {
        if (document.readyState === 'loading' && !this.waiting) {
          this.waiting = true;
          this.readyHandler = () => { this.waiting = false; if (this.isConnected) this.connectedCallback(); };
          document.addEventListener('DOMContentLoaded', this.readyHandler, { once: true });
        }
        return;
      }
      this.initialized = true;
      this.summaryHandler = this.onSummaryClick.bind(this);
      this.bodyHandler = this.onBodyClick.bind(this);
      this.keyHandler = (event) => { if (event.key === 'Escape' || event.code === 'Escape') this.close(); };
      this.closeHandler = () => this.close();
      this.resetHandler = this.reset.bind(this);
      this.closeButton = this.querySelector('.search-modal__close-button, button[type="button"]');
      this.resetButton = this.querySelector('button[type="reset"]');
      this.detailsContainer.addEventListener('keyup', this.keyHandler);
      this.summaryToggle.addEventListener('click', this.summaryHandler);
      if (this.closeButton) this.closeButton.addEventListener('click', this.closeHandler);
      if (this.resetButton) this.resetButton.addEventListener('click', this.resetHandler);
      this.summaryToggle.setAttribute('role', 'button');
      this.summaryToggle.setAttribute('aria-expanded', String(this.detailsContainer.open));
      if (this.detailsContainer.open) this.open();
    }
    disconnectedCallback() {
      if (this.readyHandler) document.removeEventListener('DOMContentLoaded', this.readyHandler);
      this.waiting = false;
      if (!this.initialized) return;
      if (this.detailsContainer.open) this.close(false);
      this.detailsContainer.removeEventListener('keyup', this.keyHandler);
      this.summaryToggle.removeEventListener('click', this.summaryHandler);
      if (this.closeButton) this.closeButton.removeEventListener('click', this.closeHandler);
      if (this.resetButton) this.resetButton.removeEventListener('click', this.resetHandler);
      document.body.removeEventListener('click', this.bodyHandler);
      this.initialized = false;
    }
    onSummaryClick(event) {
      event.preventDefault();
      this.detailsContainer.open ? this.close() : this.open();
    }
    onBodyClick(event) {
      var target = event.target;
      if (!this.contains(target) || (target.classList && target.classList.contains('modal-overlay'))) this.close();
    }
    open() {
      if (!this.detailsContainer) return;
      if (typeof setScrollbarWidth === 'function') setScrollbarWidth();
      if (typeof setHeaderBottomPosition === 'function') setHeaderBottomPosition();
      this.detailsContainer.open = true;
      this.summaryToggle.setAttribute('aria-expanded', 'true');
      document.body.addEventListener('click', this.bodyHandler);
      document.body.classList.add('search-modal--open');
      var container = this.detailsContainer.querySelector('[tabindex="-1"]') || this.detailsContainer;
      var input = this.detailsContainer.querySelector('input[type="search"], input:not([type="hidden"])');
      if (typeof trapFocus === 'function') trapFocus(container, input || this.summaryToggle);
      else if (input) input.focus();
    }
    close(restoreFocus) {
      if (!this.detailsContainer) return;
      var wasOpen = this.detailsContainer.open;
      this.detailsContainer.open = false;
      this.summaryToggle.setAttribute('aria-expanded', 'false');
      document.body.removeEventListener('click', this.bodyHandler);
      if (!document.querySelector('search-modal details[open]')) document.body.classList.remove('search-modal--open');
      if (wasOpen && typeof removeTrapFocus === 'function') removeTrapFocus();
      if (wasOpen && restoreFocus !== false && this.summaryToggle.isConnected) this.summaryToggle.focus();
      document.dispatchEvent(new CustomEvent('searchmodal:close'));
    }
    reset(event) {
      if (event) event.preventDefault();
      var input = this.querySelector('input[type="search"]');
      if (input) { input.value = ''; input.dispatchEvent(new Event('input', { bubbles: true })); input.focus(); }
    }
  }
  customElements.define('search-modal', SearchModal);
})();
